module.exports = __webpack_public_path__ + "static/media/Home.80aae446.svg";